import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import useFetch from '../../utils/useFetch'
import { fetchOrdersList, downloadRelatorioVendas } from '../../redux/actions/orders';

import { OrdersList, OrdersFilter } from '../../components/orders';
import { Loading } from '../common';

import dummyPaymentMethods from '../../dummies/paymentMethods'
import dummyPaymentStatus from '../../dummies/paymentStatus'
import { useStore } from '../../providers/store.provider';
import { SelectMultistore } from '../../components/select-multistore/select-multistore.component';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const LoadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    padding: 40px;
`

const LoadingText = styled.span`
    margin-top: 12px;
    font-size: 14px;
    color: ${(props) => props.theme.colors.textPrimary || '#666'};
`

const defaultInitDate = moment().startOf('month').toDate()
const defaultFinalDate = moment().endOf('month').toDate()

const defaultDates = { initialDate: defaultInitDate, finalDate: defaultFinalDate }

export const OrdersComponent = ({filters, handleFilter}) => {

    const dispatch = useDispatch();
    const storeProvider = useStore();
    const selectedMultistore = storeProvider.selectedMultistore?.id;

    const [isMultistore, setIsMultistore] = useState(storeProvider.getMultistoreState());
    const [reportLoading, setReportLoading] = useState(false);

    useEffect(() => {
        setIsMultistore(storeProvider.getMultistoreState())
    }, [storeProvider])

    const paymentMethods = dummyPaymentMethods
    const paymentStatus = dummyPaymentStatus

    const orders = useFetch(fetchOrdersList, filters)

    const filteredOrders = orders && orders.response && orders.response.filter(order => {
        let shouldFilter = true
        if (filters.paymentMethod > -1) {
            if (paymentMethods[filters.paymentMethod].value !== order.paymentMethod) shouldFilter = false
        }
        if (filters.paymentStatus > -1) {
            if (paymentStatus[filters.paymentStatus].value !== order.paymentStatus) shouldFilter = false
        }
        return shouldFilter
    })

    const handleGerarRelatorio = async (currentFilterValues) => {
        setReportLoading(true);
        const reportFilters = {
            ...filters,
            ...currentFilterValues,
            storeId: filters.storeId
        };
        await dispatch(downloadRelatorioVendas(reportFilters));
        setReportLoading(false);
    };

    return (
        <Wrapper>
            {
                (!isMultistore || !(isMultistore && !selectedMultistore)) ? (
                    <>
                        <OrdersFilter
                            paymentMethods={paymentMethods}
                            paymentStatus={paymentStatus}
                            defaultDates={defaultDates}
                            onFilter={handleFilter}
                            onGerarRelatorio={handleGerarRelatorio}
                            reportLoading={reportLoading}
                        />
                        {orders.loading ? (
                            <LoadingWrapper>
                                <Loading />
                                <LoadingText>Carregando pedidos...</LoadingText>
                            </LoadingWrapper>
                        ) : (
                            <OrdersList orders={filteredOrders || []} />
                        )}
                    </>
                ) :
                (
                    <SelectMultistore />
                )
            }
        </Wrapper>
    )
}
